module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/24-b0d58894e42717877fd7e803cdd9f3ae.png";